import type { Category } from '@/types/api'
import { createCrudService } from '../crud'

export type CategoryInput = Pick<
  Category,
  'parent_id' | 'image_url' | 'sort_order' | 'name_en' | 'name_ru' | 'name_uz' | 'name_cyr' | 'status'
>

export const categoriesService = createCrudService<Category, CategoryInput>('categories')
